<h1 class="page-title mb-5">قصص النجاح</h1>
<div>
  <div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9 my-5">
        <!-- Category Pills Grid -->
        <div class="categories-grid mb-4">
          <div class="category-pill" [class.active]="selectedTab === 'tab_1'" (click)="selectTab('tab_1')">الزراعة
            واستصلاح الاراضي</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_2'" (click)="selectTab('tab_2')">الصناعات
            الخشبية و الاثاث</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_3'" (click)="selectTab('tab_3')">صناعات
            تعدينية</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_4'" (click)="selectTab('tab_4')">قطاع الانتاج
            الداجني</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_5'" (click)="selectTab('tab_5')">الخدمات
            المالية والتأمين</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_6'" (click)="selectTab('tab_6')">الغاز و
            البترول</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_7'" (click)="selectTab('tab_7')">قطاع السياحة
          </div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_8'" (click)="selectTab('tab_8')">التشييد
            والبناء والعقارات</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_9'" (click)="selectTab('tab_9')">الصناعات
            الدوائية والطبية</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_10'" (click)="selectTab('tab_10')">الأتصالات و
            تكنولوجيا المعلومات</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_11'" (click)="selectTab('tab_11')">صناعة
            الجلود</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_12'" (click)="selectTab('tab_12')">التعليم
          </div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_13'" (click)="selectTab('tab_13')">الصناعات
            الهندسية والالكترونية</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_14'" (click)="selectTab('tab_14')">الكهرباء و
            الطاقة المتجددة</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_15'" (click)="selectTab('tab_15')">الخدمات
            اللوجستية والنقل</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_16'" (click)="selectTab('tab_16')">الغزل و
            النسيج</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_17'" (click)="selectTab('tab_17')">الرعاية
            الصحية</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_18'" (click)="selectTab('tab_18')">الصناعات
            الغذائية</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_19'" (click)="selectTab('tab_19')">مواد البناء
          </div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_20'" (click)="selectTab('tab_20')">تجارة
            التجزئة</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_21'" (click)="selectTab('tab_21')">
            البتروكيماويات</div>
          <div class="category-pill" [class.active]="selectedTab === 'tab_22'" (click)="selectTab('tab_22')">المنتجعات
            والقرى السياحية</div>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">
          <!-- Tab 1: Agriculture -->
          <div *ngIf="selectedTab === 'tab_1'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">الشركة المصرية للتنمية الزراعية

                  والريفية</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  نحن الشركة المصرية للتنمية الزراعية والريفية (إحدى شركات البنك الزراعي المصري)، تم تأسيس الشركة في
                  2004 ورأس المال المرخص به ثلاثة مليار جنيه مصري ورأس المال المصدر مليار ومائتان ثلاثة وأربعون مليون
                  وسبعمائة خمسة وثمانين جنيهاً مصرياً. تعمل الشركة المصرية للتنمية الزراعية والريفية كامتداد للبنك
                  الزراعي المصري في ممارسة الأعمال المرتبطة بتوفير وتسويق مستلزمات ومخرجات الإنتاج الزراعي وتخزين الحبوب
                  المختلفة على مدار العام وكذا أنشطة التصنيع الزراعي المختلفة، والمشاركة في نشر الممارسات الزراعية
                  الناجحة والتطوير الدائم والمستمر للنشاط الزراعي في الدلتا والوادي والصعيد والأراضي الجديدة وتطوير
                  أساليب تسويق وتداول المنتجات الزراعية المختلفة.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 2: Wood & Furniture note: Other tabs would follow the same pattern with their respective content -->
          <div *ngIf="selectedTab === 'tab_2'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">ايميدج</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  يوجد أول وأقدم فرع لأيميدج في مصر الجديدة - شارع صلاح سالم-. وقد فتحت فروعًا في جميع أنحاء الجمهورية
                  لتسهيل الوصول اليها وملائمة لعملائها قدر الإمكان. تقع فروعها في المهندسين ، المعادى ، ديزينوبوليس ،
                  والماظة في مصر الجديدة.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">بونوكيو</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تشغل بينوكيو بعض آلات صنع الأثاث الأكثر تقدمًا من الناحية التكنولوجية مثل: مركز حفر وتجويف الذي يتم
                  التحكم فيه PC / PLC ، ساندر الحزام الأوتوماتيكي الأوتوماتيكي.
                </p>
              </div>
            </div>
          </div>

          <!-- Add more tab content as needed -->
          <!-- Tab 3: صناعات تعدينية -->
          <div *ngIf="selectedTab === 'tab_3'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">سنتامين مصر</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  بدأت الأصول الرئيسية لشركة Centamin، منجم Sukari Gold Mine في الإنتاج عام 2009، وهي أول منجم ذهبي كبير
                  الحجم في مصر حيث وصل إنتاج قاعدة ج. 500000 أونصة سنويًا، مع إمكانية تجاوز هذا المستوى مع استمرار تحسين
                  عمليات التعدين والتجهيز.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">اتون ريسورسيز</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تركز شركة Aton Resources Inc. على امتياز أبو مروات المملوك 100٪، الواقع في الدرع العربي النوبي في مصر،
                  على بعد 200 كيلومتر تقريبًا شمال منجم الذهب التابع لشركة Centamin's Sukari.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">ايجبتالم</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  شركة Egyptalum Company هي الشركة الوحيدة المنتجة للألمنيوم الأساسي في البلاد. تبلغ الطاقة الإنتاجية
                  إلى 320،000 طن متري في السنة.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">تاني ستراتيكس ريسورسيز</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  شركة (TSR) هي شركة لاستكشاف الذهب تركز على شمال أفريقيا وشرق أفريقيا والشرق الأوسط. تم تأسيس شركة TSR
                  في أكتوبر 2014.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">فوسفات مصر</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست في عام 2009. وهي واحدة من شركتين كبيرتين تنتجان صخور الفوسفات في مصر بطاقة إنتاجية تبلغ حوالي 5
                  مليون طن سنوياً من أحد أكبر الاحتياطيات في العالم "أبو طرطور".
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 4: قطاع الانتاج الداجني -->
          <div *ngIf="selectedTab === 'tab_4'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">3A القاهرة للدواجن</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست عام 2017. تعد Cairo 3A شركة رائدة في السوق في صناعة الدواجن مع نظام تكامل رأسي متقدم للغاية
                  ومبتكر يوفر الجودة والنجاح على نطاق لا مثيل له. بعد أن حققنا نموًا هائلاً على مدار السنوات الماضية،
                  نفخر بالقول إن هذا قد سمح لنا بأن نكون المورد الحصري لأسهم الأجداد في مصر.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">مجموعة الدقهلية</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست الدقهلية منذ أكثر من 30 عامًا كشركة دواجن صغيرة من قبل الأخوين العناني ولا تزال مملوكة ملكية
                  خاصة للعائلة حتى الآن، حيث توفر ما يقرب من 30٪ من الدواجن التي يتم تربيتها محليًا في مصر.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 5: الخدمات المالية والتأمين -->
          <div *ngIf="selectedTab === 'tab_5'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">QNB الأهلي</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  QNBالأهلي هو واحد من المؤسسات المالية الرائدة في مصر التي تم تأسيسها في أبريل ١٩٧٨. يقدم البنك خدماته
                  لأكثر من مليون عميل يخدمهم أكثر من 6100 مصرفي متخصص من خلال شبكه فروع تغطى كافة محافظات مصر تصل الى
                  اكثر من 216 فرع بالإضافة إلى شبكة ممتدة من 464 جهاز صراف آلي.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">ازدهار</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تعد الشركة صندوق استثمار ذو رأس مال متنامي تأسس عام 2014 ومنذ ذلك الحين قامت الشركة بزيادة رأس المال
                  إلي أكثر من 85 مليون دولار أمريكي عن طريق ثلاث مؤسسات مالية دولية منها البنك الأوروبي لإعادة الإعمار
                  والتنمية.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">المجموعة المالية EFG Hermes</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تتخصّص المجموعة المالية هيرميس في تقديم باقة فريدة من الخدمات المالية والاستثمارية. تقدم الشركة
                  خدماتها المتنوعة في أسواق يبلغ تعدادها السكاني 2.1 مليار نسمة، حيث تعمل المجموعة المالية هيرميس في 10
                  بلاد و3 قارات حول العالم.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">المصرية للتمويل العقاري</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  الشركة المصرية للتمويل العقارى هى شركة مملوكة بالكامل لبنك كريدى اجريكول مصر وهى واحدة من اول شركات
                  القطاع الخاص المختصة بالتمويل العقارى فى مصر، تأسست عام 2004.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">بنك CIB</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسس البنك التجارى الدولى (CIB) عام 1975 هو أكبر بنك قطاع خاص مصري، ومع أكثر من 6500 موظف. يقدم البنك
                  التجاري الدولي مجموعة واسعة ومتميزة من المنتجات والخدمات البنكية لعملائه من الأفراد وأصحاب الثروات
                  والمؤسسات والشركات.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">جلوبال ليس</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست الشركة عام 2015 لتقدم مجموعة كاملة من خدمات التأجير التمويلي طبقا للمعايير الدولية. نجحت الشركة
                  في جذب الإستثمار الأجنبي المباشر في عامها الأول من الإنشاء.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">شركة ALGEBRA VENTURES المصرية للاستثمار في الخدمات المالية</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تعتبر هي أكبر صندوق تمويلي مصري في مجال صناديق رأس المال الاستثماري، أنشئت في عام 2016 من خلال مجموعة
                  من الأفراد المستثمرين الأكثر كفاءة في هذا المجال (VC) في مصر.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 6: الغاز و البترول -->
          <div *ngIf="selectedTab === 'tab_6'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">أباتشى مصر</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تعمل شركة أباتشي في مصر منذ أكثر من 20 عامًا وهي واحدة من أكبر المستثمرين الأمريكيين وأكبر منتج للنفط
                  في البلاد.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">إيني</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تعمل إيني حاليًا في مصر في قطاعات الاستكشاف والإنتاج والغاز والطاقة. يعتبر حقل ظهر أكبر اكتشاف للغاز
                  على الإطلاق في مصر والبحر الأبيض المتوسط.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">ايديسون للطاقة</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  شركة إديسون متواجدة في مصر منذ منتصف التسعينات، وتشارك بقطاع التنقيب عن النفط والغاز وإنتاجه.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">بريتش بتروليم</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تعمل الشركة في 70 دولة حول العالم. تتمتع شركة BP بسجل طويل وناجح في مصر منذ 50 عامًا.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 7: قطاع السياحة -->
          <div *ngIf="selectedTab === 'tab_7'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">أركو</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  منذ تأسيسها في عام 2005، استحوذت ARCO على أحد أكبر بنوك الأراضي في مصر، وقامت ببناء وتطوير العديد من
                  المنشآت في جميع أنحاء البلاد.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">أوراسكوم للفنادق والتنمية</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تُعد شركة أوراسكوم القابضة للتنمية شركة رائدة في تطوير المدن المتكاملة تمامًا التي تقدم الفنادق
                  والفيلات الخاصة.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">إيميكو</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  هي وكالة سياحية رائدة وشركة لإدارة الوجهات السياحية، تأسست عام 1976.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">جولدن بيراميدز بلازا (سيتي ستارز)</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  أُنشئت جولدن بيراميدز بلازا في عام 1991 وهي شركة مقرها في مصر تعمل في مجالات إدارة مرافق الترفيه
                  والضيافة.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">رمكو جروب</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست شركة رمكو لإنشاء القرى السياحية (RTVC) في عام 1995، وهى الرائدة في مجموعة شركات رمكو جروب.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">مجموعة ترافكو</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تعد مجموعة ترافكو قصة نجاح دامت ثلاثين عام في مجال السفر والسياحة.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">مصر للسياحة</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست في عام 1934 بواسطة الاقتصادي المصري الكبير طلعت حرب، لتكون أول وأقدم شركة للسياحة في مصر والشرق
                  الأوسط.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 8: التشييد والبناء والعقارات -->
          <div *ngIf="selectedTab === 'tab_8'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">إعمار</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  هي شركة مساهمة عامة تتخذ من دبي مقرا لها وتعمل في مصر تحت إدارتها شركة إعمار مصر للتنمية.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">أوراسكوم</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تعد شركة أوراسكوم القابضة للتنمية المطور الرئيسي للمدن السياحية المتكاملة.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">الأهلي للتنمية العقارية</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست الشركة عام 1994، حيث يمتلك البنك الأهلي المصري حصة 40% وعائلة صبور تمتلك 60%.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">الشركة السعودية المصرية للتعمير</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تم تأسيس شركة مساهمة مصرية عامة 1975 بموجب اتفاقية دولية خاصة.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">الشركة المصرية للمنتجعات السياحية (ERC)</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  يركز نشاط الشركة على صناعة السياحة. تمتلك الشركة مساحة أرض تبلغ 32 مليون متر مربع.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">سوديك</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست شركة سوديك في عام 1996 كشركة مساهمة عامة لتطوير المخزون العقاري.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">مجموعة طلعت مصطفى (تى إم جى) القابضة</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تى إم جى القابضة هي الشركة القابضة لمجموعة طلعت مصطفى، التي تأسست في أوائل 1960 من قبل العائلة التى
                  تحمل إسمها.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 9: الصناعات الدوائية والطبية -->
          <div *ngIf="selectedTab === 'tab_9'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">أوركيديا للصناعات الدوائية</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تختص الشركة في تصنيع عقاقير الرمد وتعتبر ثاني أكبر مُنتِج لعقاقير الرمد في مصر من بين 45 شركة دولية،
                  وإقليمية، ومحلية.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">شركة أمون للأدوية</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  شركة أمون للأدوية أحد الشركات الرائدة في إنتاج الأدوية المحلية في مصر ولديها خمس فروع منتشرة في أنحاء
                  البلاد.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 10: الأتصالات و تكنولوجيا المعلومات -->
          <div *ngIf="selectedTab === 'tab_10'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">اتصالات مصر</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  هي شكة دولية رائدة في مجال الإتصالات وتعمل في 15 بلد حول العالم وقد بدأت نشاطها في السوق المصري في
                  مايو 2007.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">اكسيد</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  شركة إكسيد هي شركة رائدة في تقديم خدمات تعهيد عمليات الشركات بعدة لغات في منطقة أوروبا والشرق الأوسط
                  وأفريقيا.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">المصرية للاتصالات</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  أصدرت شركة المصرية للاتصالات طرح أولي عام سنة 2005 حيث باعت 20% من الأسهم.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">فودافون</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تعد شركة فودافون والتي أنشئت عام 1998 تحت أسم كليك چي اس ام أكبر مشغل لخدمات المحمول.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">لينك ديفلوبمنت Link Development</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  هي من الشركات الرائدة في مجال تقديم الحلول التكنولجية. تأسست الشركة في عام 1996.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 11: صناعة الجلود -->
          <div *ngIf="selectedTab === 'tab_11'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">الإيمان للدباغة</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست شركة الإيمان للدباغة في عام 1965، وهي شركة منتجة للجلود متخصصة في تصدير المنتجات الجلدية.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">الكنز</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تم تأسيس شركة الكنز في عام 1987. منذ بداية الشركة وهي تقوم باتباع أحدث التقنيات في إنتاج الجلود
                  المصنوعة يدوياً.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">بيلا كلار للدباغة</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  بيلا كلار للدباغة متخصصة في تصنيع وتسويق المواد الكيماوية والتي تستخدم في صناعة الجلود.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">مدابغ حربي</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسس مدبغة الحربي عام 1944. وقد قامت بتأسيس مدبغة جديدة في عام 2009.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 12: التعليم -->
          <div *ngIf="selectedTab === 'tab_12'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">الجامعة الأمريكية بالقاهرة</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست الجامعة الأمريكية بالقاهرة عام 1919، وهي مؤسسة تعليمية أمريكية رائدة توفر تعليماً متميزاً باللغة
                  الإنجليزية.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">الجامعة الالمانية فى مصر</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست الجامعة الألمانية في القاهرة في عام 2002 بالتعاون مع جامعتي أولم وشتوتغارت الحكوميتين.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">الجامعة البريطانية في مصر</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست الجامعة البريطانية في مصر (BUE) فى مارس 2006 من قبل صاحب السمو الملكي أمير ويلز.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">جامعة اسلسكا (ESLSCA)</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست في عام 1949، Paris ESLSCA هي مؤسسة خاصة ومستقلة للتعليم العالي.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">جامعة الجلالة</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تعزز دور الجامعة في إنتاج ونقل المعارف والمهارات لخدمة المجتمع وتحقيق أعلى مستويات التميز الأكاديمي.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">جامعة العلمين الدولية</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  جامعة العلمين هي أحدث مؤسسة للتعليم العالي في مصر على ساحل البحر المتوسط في مصر.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">جامعة المنصورة الجديدة</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست جامعة المنصورة عام 1972 في مدينة المنصورة.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 13: الصناعات الهندسية والالكترونية -->
          <div *ngIf="selectedTab === 'tab_13'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">السويدى الكتريك</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  هي شركة تصنيع مصرية تقدم حلول الطاقة المتكاملة الآمنة والنظيفة بأسعار معقولة على المستوى المحلى
                  والعالمي وقد تأسست في عام 1938.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">سامسونج للالكترونيات</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  شركة سامسونج اليكترونكس تعمل فى مجال إنتاج التليفزيونات الالكترونية حصلت على ارض بمنطقة كوم ابو راضى
                  ببنى سويف.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">شركة ال جى اليكترونكس مصر</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  هي شركة رائدة عالميا في جنوب كوريا وصاحبة ابتكارات تكنولوجية والتي قامت بالاستثمار في مصر منذ عام
                  1991.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">شركة جوشى مصر لصناعة الفايبر جلاس ذ.م.م</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تهدف شركة جوشي مصر للفيبرجلاس المحدودة إلى خدمة أوروبا وأفريقيا والشرق الأوسط والهند من مصنعها في مصر.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 14: الكهرباء و الطاقة المتجددة -->
          <div *ngIf="selectedTab === 'tab_14'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">السويدي لتوليد طاقة الرياح</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  شركة السويدي لطاقة الرياح هي من ضمن مجموعة شركات السويدي مسئولة عن نشاط توليد طاقة الرياح.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">جنرال اليكتريك</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  هي شركة أمريكية متعددة الجنسيات، تقوم بالاستثمار في مصر لأكثر من 40 عام.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">سيمنز</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  لعبت سيمنز دورا رائعا في تشكيل التطور التكنولوجي في مصر منذ عام 1856.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 15: الخدمات اللوجستية والنقل -->
          <div *ngIf="selectedTab === 'tab_15'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">الشركة المصرية لخدمات النقل والتجارة</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست الشركة في عام 1973، وتتخصص في توفير خدمات نقل البضائع والشحن المتكاملة.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">جي بي غبور أوتو</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  جي بي غبور أوتو هي الشركة الرائدة في مجال السيارات في مصر، وتحظى بحصة سوقية ضخمة.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">شركة الملاحة الوطنية</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  أنشئت شركة الملاحة الوطنية في عام 1981.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">شركة رابطة الكويت والخليج للنقل الدولية KGL PI</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تعتبر شركة رابطة الكويت والخليج للنقل الدولية شركة تابعة لشركة النقل الكويتية KGL.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">شركة سمارت للطيران</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تعتبر سمارت للطيران شركة مساهمة بدأت عملياتها في 3 مايو 2007.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">شركة ميد ترنيان شيبنح كومباني</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  أُنشئت في عام 1970 في جنيف بسويسرا.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">مجموعة ليدر</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  أُنشئت المجموعة في عام 1996، وهي عبارة عن وكالة متخصصة في تحميل البضائع وتفريغها والشحن.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">مصر للطيران القابضة</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تعتبر مصر للطيران هي الشركة الوطنية المصرية ذات السمعة العالمية.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">مطار القاهرة الدولي</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  بحكم موقعه المتميز على مفترق طرق أفريقيا والشرق الأوسط وأوروبا والخليج الفارسي.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 16: الغزل و النسيج -->
          <div *ngIf="selectedTab === 'tab_16'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">الشركه المصريه للغزل والنسيج</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست في عام 2005، وتقع في مدينة السادات. هي شركة خاصة مملوكة من قبل إحدى الشركات الرائدة في قطاع
                  النسيج في مصر.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">النصر للملابس والغزل</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست في عام 1940، شركة النصر للملابس والمنسوجات (KABO) هي واحدة من الرواد في مجال المنسوجات والملابس
                  الجاهزة في مصر.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">شارمين للملابس و النسيج</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  هي شركة مصرية تأسست عام 1977، تنتج الملابس الداخلية القطنية وملابس النوم للرجال والنساء والأطفال.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">شركه الاسكندريه للغزل والنسيج</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست عام 1959 كواحدة من شركات الغزل الرائدة في مصر.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">عرفه للاستثمار و الاستشارات</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  شركه عرفة القابضة هي شركة رائدة عالمياً في مجال صناعة المنسوجات والملابس وتجارة التجزئة في مصر.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 18: الصناعات الغذائية -->
          <div *ngIf="selectedTab === 'tab_18'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">النيل للفواكه</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  هي شركة مستقلة بين مؤسسات الأعمال لتصنيع الفاكهة المعلبة، تأسست عام 1999.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">الوادي للصناعات الغذائية - وادي فود</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  منذ نشأتها كبستان زيتون على مساحة 30 هكتار سنة 1986، تمتلك الآن شركة وادي فود 930 هكتار.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">حلواني إخوان</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تعد شركة حلواني إخوان بمصر شركة رائدة في صناعة الأغذية في مصر ومنطقة الشرق الأوسط.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">ريجينا للمكرونة والصناعات الغذائية</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست شركة "المصرية" لصناعة المكرونة والنشويات عام 1986، وتعد ثاني أكبر شركة لصناعة المكرونة في مصر.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">شركة جهينة للصناعات الغذائية</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  من المتوقع أن تستمر شركة جهينة للصناعات الغذائية في التركيز على دفع مبيعات منتجات الألبان ذات القيمة
                  المضافة.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 19: مواد البناء -->
          <div *ngIf="selectedTab === 'tab_19'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">حديد عز</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  يعتبر حديد عز أكبر الشركات انتاجا للحديد والصلب في الشرق الأوسط وشمال أفريقيا ، حيث تصدر منتجات الصلب
                  عالية الجودة إلى العديد من البلدان في أربع قارات حول العالم. لقد أصبح إنتاجَا كَبِيرَةً عالي في صناعة
                  الصلب ، وقدوة للطريق من خلال اعتماد افضل ممارسات الصناعة في صناعة الصلب الأكثر تطورا.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 20: تجارة التجزئة -->
          <div *ngIf="selectedTab === 'tab_20'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">سوق دوت كوم</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  هو سوق تجاري إلكتروني ضخم في الإمارات وتم الاستحواذ عليه مؤخرًا من قبل عملاق التجارة الإلكترونية موقع
                  "أمازون". بدء عمل "سوق.كوم" في مصر عام 2010 مستفيدًا من النمو السريع في سوق المستهلك والاستخدام العالي
                  لشبكة الإنترنت. يبلغ عدد العاملين به حاليًا 650 عامل وأنه مستوى يبلغ مساحته أكثر من 10,000 من مربع.
                  ويجذب الموقع أكثر من 30 مليون زيارة يوميًا. بلغ إجمالي قيم من المنظمة لنصف منتجات السلع لديه في أكثر
                  من 500,00 منتج فريد من نوعه في 20 فئه مختلفة تشمل الأدوات الإلكترونية والسلع المنزلية والساعات والعطور
                  والألعاب ومنتجات الأطفال.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">كاربون</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  هو سوق تجاري إلكتروني ضخم في الإمارات وتم الاستحواذ عليه مؤخرًا من قبل عملاق التجارة الإلكترونية موقع
                  "أمازون". بدء عمل "سوق.كوم" في مصر عام 2010 مستفيدًا من النمو السريع في سوق المستهلك والاستخدام العالي
                  لشبكة الإنترنت. يبلغ عدد العاملين به حاليًا 650 عامل وأنه مستوى يبلغ مساحته أكثر من 10,000 من مربع.
                  ويجذب الموقع أكثر من 30 مليون زيارة يوميًا. بلغ إجمالي قيم من المنظمة لنصف منتجات السلع لديه في أكثر
                  من 500,00 منتج فريد من نوعه في 20 فئه مختلفة تشمل الأدوات الإلكترونية والسلع المنزلية والساعات والعطور
                  والألعاب ومنتجات الأطفال.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 21: البتروكيماويات -->
          <div *ngIf="selectedTab === 'tab_21'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">سيدكي كربر للبتروكيماويات - سيديك</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  شركة سيدكي كربر للبتروكيماويات "سيديك" هي شركة مساهمة مصرية تأسست في 16 نوفمبر 1997 بموجب قانون
                  الاستثمار المصري وتقع في منطقة الإسكندرية الحرة للبترول وكيماويات، وتعمل في قطاع البتروكيماويات التابع
                  لوزارة البترول تمتلك مصانع بمدينة الإسكندرية – طريق القاهرة / الإسكندرية الصحراوي. عولت شركة سيديك في
                  16 نوفمبر من عام 1997 تحت مظله قانون الاستثمار المصري ضمن استراتيجية وزارة البترول المصرية في إنشاء
                  صناعة متقدمة للبتروكيماويات. وذلك لتحقيق الاستغلال الأمثل لاحتياطيات مصر من الغاز الطبيعى. تشغل سيديك
                  نيابة يكون أول شركة مصرية تقوم بإنشاع الستيلين ومود المادة الرئيسية في صناعة البولي إيتيلين حيث تقوم
                  شركة سيديك بإنتاج مادة البولي إيتلانيا بإنتاج بونيجاها على الكثافة المنخفضة الخطية تحت الاسم التجاري
                  EGYPTENE بالإضافة إلى منتجى البنزين-1 وغاز البروبانز (LPG).
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">شركة مصر للإنتاج الأسمدة - موبكو</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  تأسست شركة موبكو، إحدى شركات قطاع البترول، في 26 يوليو 1998 وفقًا لقواعد وأحكام قانون ضمانات وحوافز
                  الاستثمار رقم 8 الصادر عام 1997 داخل المنطقة الحرة بدمياط على مساحة 400,000 متر مربع مخصصة لمشروع
                  منشأة كاملة لإنتاج الأمونيا ومشروع موبكو. بعد الحصول على تصائل درامل من الدفل الوطنية والدواليه، على
                  الرغم من الظروف الاقتصادية الحادثة في شركة أول مشروع موبكو نفذ فور الحصول على تصائل (1,050) مليار
                  دولار من الدول الوطنية والدولية في 31 مارس 2016 وهي بداية العام التشغيل الألماني. وكذلك شركة ترابويت
                  لإنشراء وتحديل لإنتاج الموميا نحو اسعة (2400) طن في اليوم.
                </p>
              </div>
            </div>
            <div class="story-card mt-3">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">ميدور</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  ميدور هي شركة مساهمة مصرية تأسست في 12/07/1994 بموجب المرسوم الوزاري رقم 323 وفقًا للوائح المنطقة
                  الحرة العامة وقانون الاستثمار رقم 230 لسنة 1989 وتعديلاته. بهدف تحسين وتطوير نشاط تكرير النفط الخام
                  وإنتاج منتجات نفطية عالية الجودة، للأسواق المحلية والدولية. يصنف معمل تكرير شركة ميدور كمعامل تحويل
                  عميقة باستخدام أحدث الأساليب العلمية والتكنولوجية لتتناسب مع احتياجات السوق المتزايد. تبلغ استثمارات
                  المعامل بها بقرب من 1.4 مليار دولار أمريكي ، القدرة التصميمية 115000 برميل / يوم معمرة ميدور تعدل
                  خليخيل ، 500 مان داخل المنطقة الحرة العامرية غرب مدينة الإسكندرية بشمال على ، 5 كم أرض تقستخدم الصناعة
                  الصويوتروبية للموقع. تعتبر ميدور واحدة من أوائل المعامل في السوق الأوسط المعممة للتعامل مع التعاصير
                  البنية العالمية الأكثر تطلبا لعمعالجة منهه الصرف الصحى ومواصفات المنتج.
                </p>
              </div>
            </div>
          </div>

          <!-- Tab 22: المنتجعات والقرى السياحية -->
          <div *ngIf="selectedTab === 'tab_22'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">فندق ادرير اميلال - واحة سيوة</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  يقع فندق أدرير أميلال، عبر مصر، في واحة سيوة والتي، يُعد بها ما يقرب من تحالى، سكان من الواحات
                  بالسلام، ومصر وقلىا يد جسنة - يوامل، الواحة بازها: ''ال يمكن القول أن واحة سيوة هو سقطت من مكانها
                  العالية ... وأيضًا طلب قائدة في الوقت الذي أستر فيه العالم في التعميرً. مصر المدد، العكبر شهرة في
                  الصعيه الواقعة عند سفح جبل ''واثب'' وهو عبارة عن فندق يصفته صخرتين تواه معزوفه تم بناء من المباني
                  الأرضية التي احمركت بشكل طبيعى. مع المنيفة التطبيعية يدعي معقوق لكن طريق، منايب للبيئة المائية
                  بالاضواف، اي: بتال المال، الاتصعم، من منزع انوي وود كفهرراً فان العرف بضاء إضافة كاملة عن طريق التى
                  عقىير إصعقق صغمة من شمع العملا والسقاء المزجمة بالنجوم.
                </p>
              </div>
            </div>
          </div>

          <div *ngIf="selectedTab === 'tab_17'" class="success-stories">
            <div class="story-card">
              <div class="story-header">
                <span class="story-marker">>></span>
                <h3 class="story-title">المستشفى السعودي الألماني</h3>
              </div>
              <div class="story-body">
                <p class="story-description">
                  يعتبر الفرع الجديد لمستشفى السعودي الألماني في القاهرة الخطوة الأولى نحو إنشاء عدد من الفروع الأخرى في
                  العديد من المحافظات في مصر في السنوات القادمة في القاهرة بحجم استثمار يتجاوز مليار جنيه مصري.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="col-md-3">
        <app-fix-left-section></app-fix-left-section>
      </div>
    </div>
  </div>
</div>